import React from "react";
import { WHATSAPP_NUMBER } from "../lib/api";
import { MessageCircle } from "lucide-react";

export default function WhatsAppCTA() {
  const num = WHATSAPP_NUMBER.replace(/[^0-9]/g, "");
  const href = `https://wa.me/${num}?text=${encodeURIComponent(
    "Bonjour Riviera Shockwaves, je souhaite réserver une session VIP — à bord ou à domicile."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-cta"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[var(--ink)] hover:bg-[var(--gold)] text-[var(--bg-base)] border border-[var(--gold)]/40 rounded-full px-4 py-3 shadow-2xl transition-all"
      style={{ boxShadow: "0 18px 38px -10px rgba(26,26,32,0.35)" }}
    >
      <MessageCircle size={18} className="text-[var(--gold)]" />
      <span className="font-display text-[11px] uppercase tracking-[0.18em]">WhatsApp</span>
    </a>
  );
}
